module.exports = __webpack_public_path__ + "static/media/image_4.74ce6e1b.png";